<div class="">
    @if (isCameraExist) {
    <div>
        <div style="text-align:center">
            <!-- <div class="row g-0">
        <button *ngIf="!search" mat-raised-button class="col mx-1" (click)="takeSnapshot()">Commencer à scanner !</button>
        <button *ngIf="search" mat-raised-button class="col mx-1" (click)="takeSnapshot()">Arrêter de scanner !</button>
        <button *ngIf="CameraCount > 1" mat-raised-button class="col mx-1" (click)="changeWebCame(true)">Changer Camera</button>
        <button class="button" (click)="onOffWebCame()">Switch camera</button>
      </div> <br /> -->
            @if (showWebcam) {
            <webcam [height]="WEBCAM_DISPLAY_HEIGHT" [width]="WEBCAM_DISPLAY_WIDTH" [trigger]="triggerObservable" (imageCapture)="handleImage($event)"
                    [switchCamera]="nextWebcamObservable" [videoOptions]="videoOptions" [captureImageData]="true">
            </webcam>
            }
        </div>
        @if (errors.length > 0) {
        <div>
            <h4>Error Messages:</h4>
            @for (error of errors; track error) {
            <ul>
                <li>{{ error | json }}</li>
            </ul>
            }
        </div>
        }
    </div>
    } @else {
    Camera device not available
    }

</div>